import React from 'react';
import { useTranslation } from 'react-i18next';
import { Numbers, Statistics } from '@weezevent/nacre';
import { Loader } from 'semantic-ui-react';
import Style from './sales.module.css';
import i18n from 'i18next';

const SalesReportStatistic = ({ subtitle, stat, currency = null, isLoading }) => {
    const locale = i18n.language;
    if (isLoading) {
        return (
            <Statistics stat="" className={Style['statistic_placeholder']} minHeightHeader={'12px'}>
                <Loader active inline="centered" />
            </Statistics>
        );
    }
    return <Statistics subtitle={subtitle} stat={<Numbers value={stat} showNullDecimal currency={currency} locale={locale} />} />;
};

const SalesReportHeader = ({ currency = 'EUR', data = null }) => {
    const { t } = useTranslation();
    const isLoading = React.useMemo(() => {
        return Boolean(!data);
    });
    return (
        <>
            <Statistics.Group className={'contentState'}>
                <SalesReportStatistic subtitle={t('ticket.sales_report.stats.ticket_sales')} stat={data?.global_count} isLoading={isLoading} />
                <SalesReportStatistic subtitle={t('ticket.sales_report.stats.ticket_refund')} stat={Number(data?.global_count_refund)} isLoading={isLoading} />
                <SalesReportStatistic
                    subtitle={t('ticket.sales_report.stats.turnover')}
                    stat={data?.global_sum - data?.global_sum_refund}
                    currency={currency}
                    isLoading={isLoading}
                />
            </Statistics.Group>
        </>
    );
};

export default SalesReportHeader;
